module.exports = __webpack_public_path__ + "img/gg-2.6efbc787.png";